
import { mapGetters } from 'vuex'

export default {
  head() {
    return {
      title: this.$t('search'),
    }
  },

  computed: {
    ...mapGetters('search', ['productResults', 'pageResults']),
  },
}
